<template>
  <div>
    <!-- <facebook-login
      appId="654763245426257"
      @login="onLogin"
      @logout="onLogout"
      @sdk-loaded="sdkLoaded"
    >
    </facebook-login> -->
    <!-- <v-facebook-login
      v-model="useValue"
      @sdk-init="handleSdkInit"
      app-id="654763245426257"
    ></v-facebook-login> -->
    <!-- <button class="button" @click="logInWithFacebook">
      Login with Facebook
    </button> -->
    <!-- <v-facebook-login
      v-model="useValue"
      @sdk-init="handleSdkInit"
      @login="getUserData"
      app-id="665260234242386"
      class="v-facebook-login"
    >
      <template #logo>
        <img
          src="@/assets/icons/facebook.svg"
          height="24"
          width="24"
          style="margin-right: 7px; padding-top: 1px"
        />
      </template>
      <template #login>
        <b style="font-size: 16px">Sign in with Facebook</b>
      </template>
    </v-facebook-login> -->
    <!-- <button v-if="scope.logout && model.connected" @click="scope.logout">
      Logout
    </button>-->
  </div>
</template>

<script>
// app ID for testing : 665260234242386
// app ID for mdl: 654763245426257
// import VFacebookLogin from "vue-facebook-login-component";
// import facebookLogin from "facebook-login-vuejs";
import { mapGetters } from "vuex";

export default {
  components: {
    // VFacebookLogin,
    // facebookLogin,
  },
  props: {
    value: Object,
  },
  data: () => ({
    // FB: {},
    model: {},
    scope: {},
    accessToken: "",
    useValue: {},
    isConnected: false,
    name: "",
    email: "",
    personalID: "",
    FB: undefined,
    authData: null,
  }),
   watch: {
    value(value) {
      this.username = value;
    },
  },
  methods: {
    handleSdkInit({ FB, scope }) {
      this.FB = FB;
      this.scope = scope;
    },
    getUserData() {
      this.FB.api("/me", "GET", (response) => {
        this.personalID = response.id;
        this.email = response.email;
        this.name = response.name;
        let body = {
          accessToken: response.access_token,
        };
      });
    },
    sdkLoaded(payload) {
      this.isConnected = payload.isConnected;
      this.FB = payload.FB;
      if (this.isConnected) this.getUserData();
    },
    onLogin() {
      this.isConnected = true;
      this.getUserData();
      this.FB.getLoginStatus(function (response) {
        if (response.status === "connected") {
          if (response.authResponse.access_token !== "") {
            let body = {
              accessToken: response.authResponse.access_token,
            };
            //this.$store.dispatch("auth/loginFacebook", body);
          }
        }
      });
    },
    onLogout() {
      this.isConnected = false;
      this.personalID = "";
      this.email = "";
      this.name = "";
    },
  },
 
};
</script>

<style scoped>
.v-facebook-login {
  outline: none;
  border: none;
  width: 100%;
  text-align: center;
  padding-top: 14px;
  padding-bottom: 1rem;
  border-radius: 40px;
  font-size: 14px;
  color: #fff;
  background-color: #3c57a4;
  border: 1px solid rgb(204, 204, 204);
  padding: 10px;
  border-radius: 25px;
}
.v-facebook-login[data-v-c9fa963e] {
  outline: none;
  border: none;
  width: 100%;
  text-align: center;
  padding-top: 14px;
  padding-bottom: 1rem;
  border-radius: 40px;
  font-size: 14px;
  color: #fff;
  background-color: #3c57a4;
  border: 1px solid rgb(204, 204, 204);
  padding: 10px;
  border-radius: 25px;
}
</style>
